import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'

// Re-export routes for convenience
export { routes } from './routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

export default router
